import { Component } from '@angular/core';
import { toggleAnimation } from 'src/app/shared/animations';
import { Store } from '@ngrx/store';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { AppService } from '../service/app.service';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../service/auth/auth.service';
import { AlertService } from '../service/alerts.service';
import { filter, map, mergeMap, Subject, takeUntil } from 'rxjs';
import { environment } from '../../environments/environment';

@Component({
    selector: 'header',
    templateUrl: './header.html',
    animations: [toggleAnimation],
})
export class HeaderComponent {
    store: any;
    search = false;

    name_shortcut: any;
    userData: any;
    pageTitle: string = 'Tableau de bord';
    private destroy$ = new Subject<void>();

    // Environment badge
    envBadge = environment.badge_env;

    constructor(
        public translate: TranslateService,
        public storeData: Store<any>,
        public router: Router,
        private appSetting: AppService,
        private sanitizer: DomSanitizer,
        public authService: AuthService,
        public alertService: AlertService,
        private activatedRoute: ActivatedRoute
    ) {
        this.initStore();
    }
    async initStore() {
        this.storeData
            .select((d) => d.index)
            .subscribe((d) => {
                this.store = d;
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private updateTitle(): void {
        let route = this.activatedRoute;
        while (route.firstChild) {
          route = route.firstChild;
        }
        
        route.data.subscribe(data => {
          this.pageTitle = data['title'] || 'Tableau de bord';
        });
    }

    ngOnInit() {
        this.userData = this.authService.getUserData()
        this.setActiveDropdown();
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.setActiveDropdown();
            }
        });
        this.name_shortcut = this.userData.nom && this.userData.prenom ? `${this.userData.nom} ${this.userData.prenom}` : this.userData.name
        this.name_shortcut = this.name_shortcut.split(' ')
        .slice(0, 2)
        .map((word : any) => word[0].toUpperCase())
        .join('');

        this.updateTitle();

        // Listen to router events to update title
        this.router.events
        .pipe(
            filter(event => event instanceof NavigationEnd),
            takeUntil(this.destroy$)
        )
        .subscribe(() => {
            this.updateTitle();
        });
        
    }

    setActiveDropdown() {
        const selector = document.querySelector('ul.horizontal-menu a[routerLink="' + window.location.pathname + '"]');
        if (selector) {
            selector.classList.add('active');
            const all: any = document.querySelectorAll('ul.horizontal-menu .nav-link.active');
            for (let i = 0; i < all.length; i++) {
                all[0]?.classList.remove('active');
            }
            const ul: any = selector.closest('ul.sub-menu');
            if (ul) {
                let ele: any = ul.closest('li.menu').querySelectorAll('.nav-link');
                if (ele) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele?.classList.add('active');
                    });
                }
            }
        }
    }

    getDisplayName(): string {
        const nom = this.userData?.nom;
        const prenom = this.userData?.prenom;

        // Si les deux existent et ne sont pas null/vides
        if (nom && nom.trim() && prenom && prenom.trim()) {
            return `${nom.trim()} ${prenom.trim()}`;
        }

        // Si seulement le nom existe
        if (nom && nom.trim()) {
            return nom.trim();
        }

        // Si seulement le prénom existe
        if (prenom && prenom.trim()) {
            return prenom.trim();
        }

        // Sinon afficher '-'
        return '-';
    }

    async logout() {

      let alertOptions = {
        title : "Se déconnecter",
        text : "Êtes-vous sûr de vouloir vous déconnecter ?",
        confirmButtonText : "Confirmer",
        cancelButtonText : "Annuler",
      }
      let isConfirmed = await this.alertService.confirmDialog(alertOptions)
      if (isConfirmed) {
        
        this.authService.logout()
      }
    }
}
